export const appDefaultLocale = "es-ES";
